import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('../pages/home/index.vue')
const Mine = () => import('../pages/mine/index.vue')
const Choose = () => import('../pages/choose/index.vue')
const Reviews = () => import('../pages/reviews/index.vue')
const List = () => import('../pages/choose/list.vue')
const Profile = () => import('../pages/choose/profile.vue')
const Video = () => import('../pages/video/index.vue')
const Game = () => import('../pages/game/index.vue')
const Login = () => import('../pages/login/index.vue')
const Register = () => import('../pages/login/register.vue')
const ServiceOnline = () => import('../pages/mine/ServiceOnline.vue')
const ServicePage = () => import('../pages/mine/ServicePage.vue')
const Setting = () => import('../pages/mine/Setting.vue')
const Infomation = () => import('../pages/mine/Infomation.vue')
const IndexInfo = () => import('../pages/mine/IndexInfo.vue')
const Setname = () => import('../pages/mine/Setname.vue')
const Language = () => import('../pages/mine/Language.vue')
const Setsex = () => import('../pages/mine/Setsex.vue')
const Recharge = () => import('../pages/mine/Recharge.vue')
const RechargeList = () => import('../pages/mine/RechargeList.vue')
const SetPayPassword = () => import('../pages/mine/SetPayPassword.vue')
const SetLoginPassword = () => import('../pages/mine/SetLoginPassword.vue')
const Lottery = () => import('../pages/lottery/index.vue')
const Notice = () => import('../pages/mine/Notice.vue')
const PlayVideo = () => import('../pages/video/PlayVideo')
const Setbank = () => import('../pages/mine/Setbank')
const BindCard = () => import('../pages/mine/BindCard')
const Withdraw = () => import('../pages/mine/Withdraw')
const Personalreport = () => import('../pages/mine/Personalreport')
const GameRecord = () => import('../pages/mine/GameRecord')
const WithdrawRecord = () => import('../pages/mine/WithdrawRecord')
const Details = () => import('../pages/mine/details')

Vue.use(VueRouter)
const routes = [
    // {path:'/',redirect:'/Home',component:Home,meta:{title:'첫 페이지'}},
    // {path:'/Home',name:'home',component:Home,meta:{title:'첫 페이지'}},
	// {path:'/Choose',name:'choose',component:Choose,meta:{title:'첩을 선택하세요'}},
	// {path:'/List',name:'list',component:List,meta:{title:'선택된 첩 목록'}},
	// {path:'/Profile',name:'profile',component:Profile,meta:{title:'첩 선택 세부 사항'}},
    // {path:'/Mine',name:'mine',component:Mine,meta:{title:'내 거'}},
    // {path:'/Video',name:'video',component:Video,meta:{title:'동영상'}},
    // {path:'/Game',name:'game',component:Game,meta:{title:'게임'}},
    // {path:'/Login',name:'login',component:Login,meta:{title:'로그인'}},
    // {path:'/Register',name:'register',component:Register,meta:{title:'등록하다'}},
    // {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'온라인 고객 서비스'}},
    // {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'온라인 고객 서비스'}},
    // {path:'/Setting',name:'Setting',component:Setting,meta:{title:'설정'}},
    // {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'기본정보'}},
    // {path:'/IndexInfo',name:'IndexInfo',component:IndexInfo,meta:{title:'설정'}},
    // {path:'/Setname',name:'Setname',component:Setname,meta:{title:'실명 변경'}},
    // {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'성별 수정'}},
    // {path:'/Language',name:'Language',component:Language,meta:{title:'언어 선택'}},
    // {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'충전하다'}},
    // {path:'/RechargeList',name:'RechargeList',component:RechargeList,meta:{title:'충전하다'}},
    
    // {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'결제 비밀번호 관리'}},
    // {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'로그인 비밀번호 관리'}},
    // {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'세부정보 페이지'}},
    // {path:'/Notice',name:'Notice',component:Notice,meta:{title:'정보발표'}},
    // {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'비디오 재생'}},
    // {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'결제 카드를 작성하세요'}},
    // {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'결제 카드를 작성하세요'}},
    // {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'현금 인출'}},
    // {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'개인 보고서'}},
    // {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'출금기록'}},
    // {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'작업 기록'}},
    // {path:'/detail',name:'Details',component:Details}
    {path:'/',redirect:'/Home',component:Home,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'さくらふぶきクラブ'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'さくらふぶきクラブ'}},
        {path:'/Reviews',name:'reviews',component:Reviews,meta:{title:'さくらふぶきクラブ'}},
	{path:'/List',name:'list',component:List,meta:{title:'さくらふぶきクラブ'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'さくらふぶきクラブ'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'さくらふぶきクラブ'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'さくらふぶきクラブ'}},
    {path:'/IndexInfo',name:'IndexInfo',component:IndexInfo,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'さくらふぶきクラブ'}},
    {path:'/RechargeList',name:'RechargeList',component:RechargeList,meta:{title:'さくらふぶきクラブ'}},
    
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'さくらふぶきクラブ'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'さくらふぶきクラブ'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'さくらふぶきクラブ'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'さくらふぶきクラブ'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'さくらふぶきクラブ'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'さくらふぶきクラブ'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'さくらふぶきクラブ'}},
    {path:'/detail',name:'Details',component:Details,meta:{title:'さくらふぶきクラブ'}}

];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    document.title = 'LOVE TALK CLUB'
    next()
})

export default router
